import { z } from 'zod';

const EvmAddress = z.string().regex(/^0x[a-fA-F0-9]{40}$/, 'Must be a 0x-prefixed EVM address');

export const WalletSchema = z.object({
  id: z.number().int().positive(),
  address: EvmAddress,
  label: z.string().min(1),
  createdAt: z.number().int().nonnegative(),
});

export const CreateWalletRequestSchema = z.object({
  address: EvmAddress,
  label: z.string().min(1).max(120),
  // When omitted, the server links the wallet to all currently enabled chains.
  // When provided, every id must reference an existing, enabled chain.
  chainIds: z.array(z.number().int().positive()).min(1).max(100).optional(),
});

export type WalletDto = z.infer<typeof WalletSchema>;
export type CreateWalletRequest = z.infer<typeof CreateWalletRequestSchema>;
